import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')
const Display = () => import('./views/Display')
const Check = () => import('./views/Check')

const ROUTE_NAME = 'profile:homework:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')
const CREATE = p('create')
const CHECK = p('check')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
    }),
    route(':lesson/create/', Display, CREATE, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
      props: true,
    }),
    route(':id/detail/', Display, DISPLAY, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
      props: true,
    }),
    route(':id/check/', Check, CHECK, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
      props: true,
    }),
  ]
}
